import request from "../Utils/Request";

export function getData(url: string) {
  return request.get(url);
}
